<template>
  <div class="order">
    <div class="head">
      <AppFrame/>
    </div>
    <div class="cont">
      <div class="van-cont-block">
        <van-form ref="submitForm">
          <p class="van-cont__title">收货单位</p>
          <van-field
            readonly
            clickable
            name="receiverName"
            :value="subForm.receiverName"
            label="收货单位"
            placeholder="请选择"
            @click="getListWithRawMaterial()"
            right-icon="arrow"
          ></van-field>
          <van-field
            readonly
            clickable
            name="receiverAlias"
            :value="subForm.receiverAlias"
            label="收货地点"
            placeholder="请选择"
            @click="openReceiverAddressList()"
            right-icon="arrow"
          ></van-field>
          <van-field
            readonly
            clickable
            name="receiverContacts"
            :value="subForm.receiverContacts"
            label="联系人"
            placeholder="自动带出"
          ></van-field>
          <van-field
            readonly
            clickable
            name="receiverTel"
            :value="subForm.receiverTel"
            label="手机/电话"
            placeholder="自动带出"
          ></van-field>
          <van-field
            readonly
            clickable
            name="receiverRegionName"
            :value="subForm.receiverRegionName"
            label="省市区"
            placeholder="自动带出"
          ></van-field>
          <van-field
            readonly
            clickable
            name="receiverAddress"
            :value="subForm.receiverAddress"
            label="详细地址"
            placeholder="自动带出"
          ></van-field>
          <p class="van-cont__title">货品清单</p>
          <van-field
            readonly
            clickable
            name="prodName"
            :value="subForm.supplyTransportGoodsFormList[0].prodName"
            label="货品名称"
            placeholder="请选择"
            @click="getProductsByErp()"
            right-icon="arrow"
          ></van-field>
          <van-field
            type="number"
            label="计划发货量"
            name="supplyTransportGoodsFormList[0].amount"
            v-model="subForm.supplyTransportGoodsFormList[0].amount"
            placeholder="请输入"
            @click-right-icon="showPickerProductUnits = true"
          >
            <template #right-icon>
              <span class="c-333">单位：</span>
            </template>
            <template #extra>
              <span v-html="subForm.supplyTransportGoodsFormList[0].amountUnitStr"></span>
              <van-icon name="arrow" class="search-icon" />
            </template>
          </van-field>
          <van-field
            name="price"
            v-model="subForm.supplyTransportGoodsFormList[0].price"
            type="number"
            label="货品赔付价"
            placeholder="请输入赔付价"
          >
            <template #extra>
              &nbsp;&nbsp;元
            </template>
          </van-field>
          <p class="van-cont__title">供应商</p>
          <van-field
            readonly
            clickable
            name="consignerName"
            :value="subForm.consignerName"
            label="发货单位"
            placeholder="请选择"
            @click="getconsignerByErp(1)"
            right-icon="arrow"
          ></van-field>
          <van-field
            readonly
            clickable
            name="supplyTime"
            :value="subForm.supplyTime"
            label="发货时间"
            placeholder="请选择"
            @click="showPickerSupplyTime = true"
            is-link
          ></van-field>
          <van-field
            readonly
            clickable
            name="consignerAlias"
            :value="subForm.consignerAlias"
            label="发货地点"
            placeholder="请选择"
            @click="showPickerConsignerAddress = true"
            right-icon="arrow"
          ></van-field>
          <van-field
            v-model="subForm.supplyTransportGoodsFormList[0].tranRequire"
            label="服务要求"
            placeholder="请输入服务要求"
            type="textarea"
          ></van-field>
          <div style="margin: 16px;">
            <van-button block type="info" @click="onSubmit">
              提交
            </van-button>
          </div>
          <div style="height: 240px"></div>
        </van-form>
      </div>
    </div>
    <!-- 选择收货单位 -->
    <van-popup
      v-model="showPickerWithRawMaterial"
      position="right"
      :style="{ width: '100%',height: '100%' }"
    >
      <div class="search-box-arrow-left">
        <van-nav-bar
          left-arrow
          @click-left="onClickLeft"
        >
          <template #title>
            <van-search v-model="receiverSval" shape="round" clearable :placeholder="'搜索单位名称'" :left-icon="require('@/styles/img/icon_search.png')" background="transparent" @search="receiverSFun"/>
          </template>
        </van-nav-bar>
        <div class="search-list">
          <van-list>
            <van-cell v-for="(item,index) in withRawMaterialList" :key="index" :title="item.name" @click="changeWithRawMaterialList(item)">
                <template #icon>
                  <van-icon v-if="item.id==subForm.receiverId" name="checked" class="search-icon" color="#4687F5" />
                  <van-icon v-else name="hotel-o" class="search-icon"/>
                </template>
              </van-cell>
          </van-list>
        </div>
      </div>
    </van-popup>
    <!-- 选择发货地点 -->
    <van-popup v-model="showPickerReceiverAddress" position="bottom" safe-area-inset-bottom>
      <van-picker
        show-toolbar
        :columns="receiverAddressList"
        value-key="name"
        @confirm="onConfirmReceiverAddressList"
        @cancel="showPickerReceiverAddress = false"
      ></van-picker>
    </van-popup>
    <!-- 选择货品名称 -->
    <van-popup
      v-model="showPickerProducts"
      position="right"
      :style="{ width: '100%',height: '100%' }"
    >
      <div class="search-box-arrow-left">
        <van-nav-bar
          left-arrow
          @click-left="onClickLeft"
        >
          <template #title>
            <van-search v-model="productsSval" shape="round" clearable :placeholder="'搜索货品名称'" :left-icon="require('@/styles/img/icon_search.png')" background="transparent" @search="getProductsByErp()"/>
          </template>
        </van-nav-bar>
        <div class="search-list">
          <van-list>
            <van-cell v-for="(item,index) in productsList" :key="index" :title="item.name" @click="changeGoods(item)">
              <template #icon>
                <van-icon v-if="item.name==subForm.supplyTransportGoodsFormList[0].prodName" name="checked" class="search-icon" color="#4687F5" />
                <van-icon v-else name="circle" class="search-icon"/>
              </template>
            </van-cell>
          </van-list>
        </div>
      </div>
    </van-popup>
    <!-- 选择计量单位 -->
    <van-popup v-model="showPickerProductUnits" position="bottom" safe-area-inset-bottom>
      <van-picker
        show-toolbar
        :columns="productUnitsList"
        value-key="name"
        @confirm="onConfirmProductUnits"
        @cancel="showPickerProductUnits = false"
      ></van-picker>
    </van-popup>
    <!-- 选择发货单位 -->
    <van-popup
      v-model="showPickerConsigner"
      position="right"
      :style="{ width: '100%',height: '100%' }"
    >
      <div class="search-box-arrow-left">
        <van-nav-bar
          left-arrow
          @click-left="onClickLeft"
        >
          <template #title>
            <van-search v-model="consignerSval" shape="round" clearable :placeholder="'搜索单位名称'" :left-icon="require('@/styles/img/icon_search.png')" background="transparent" @search="consignerSFun"/>
          </template>
        </van-nav-bar>
        <div class="search-list">
          <van-list>
            <van-cell v-for="(item,index) in consigneesGetList" :key="index" :title="item.name" @click="changeConsignerByErp(item)">
                <template #icon>
                  <van-icon v-if="item.id==subForm.consignerId" name="checked" class="search-icon" color="#4687F5" />
                  <van-icon v-else name="hotel-o" class="search-icon"/>
                </template>
              </van-cell>
          </van-list>
        </div>
      </div>
    </van-popup>
    <!-- 选择发货地点 -->
    <van-popup v-model="showPickerConsignerAddress" position="bottom" safe-area-inset-bottom>
      <van-picker
        show-toolbar
        :columns="consignerAddressList"
        value-key="name"
        @confirm="onConfirmConsignerAddressList"
        @cancel="showPickerConsignerAddress = false"
      ></van-picker>
    </van-popup>
    <!--选择发货时间-->
    <van-popup v-model="showPickerSupplyTime" position="bottom" safe-area-inset-bottom>
      <van-datetime-picker
        type="date"
        v-model="supplyTime"
        @confirm="onConfirmSupplyTime"
        @cancel="showPickerSupplyTime = false"
      ></van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
import AppFrame from '@/components/AppFrame'
import AreaList from "@/untils/area";
import SearchBar from '../../components/SearchBar/index'
export default {
  name: "AddInvoice",
  components: {
    AppFrame,
    SearchBar
  },
  data() {
    return {
      goodsValue:'',        //货品搜索
      receiverSval: '',     //收货单位搜索
      consignerSval: '',    //发货单位搜索
      productsSval: '',     //货品名称搜索
      showPickerWithRawMaterial: false, //收货单位列表显示隐藏
      withRawMaterialList:[],           //收货单位列表
      showPickerReceiverAddress: false, //收货地点选择器显示隐藏
      receiverAddressList: [],          //收货地点列表
      showPickerProducts: false,        //货品名称选择器显示隐藏
      productsList: [],                 //货品名称列表
      receiver_id: '',                  //ERP收货单位Id，取ext3请求时需要
      showPickerProductUnits: false,    //计量单位选择器显示隐藏
      productUnitsList: [],             //计量单位列表
      showPickerSupplyTime: false,      //发货时间选择器显示隐藏
      supplyTime: '',	                  //发货时间
      showPickerConsigner: false,       //选择发货单位显示隐藏
      consigneesGetList:[],             //发货单位地址列表
      showPickerConsignerAddress: false,//发货地点选择器显示隐藏
      consignerAddressList: [],         //发货地点列表
      subForm: {
        receiverId: '',	            //Y	收货单位id
        receiverName: '',	          //Y	收货单位名称
        receiverAddressId: '',	    //Y	收货地点id
        receiverAddress: '',	      //Y	收货地点名称
        receiverAlias: '',	        //Y	收货地点简称
        receiverContacts: '',       //Y 收货联系人
        receiverRegionName: '',     //Y	收货省市区
        receiverRegionid: '',       //Y	收货地点邮编
        receiverTel: '',            //Y	收货地点手机电话

        consignerMedialID: '',      //Y	ERP发货单位Id
        consignerName: '',          //Y	发货单位名称
        consignerCode: '',	        //Y	ERP发货单位NC编码
        consignerAddressMedialID: '',	//Y	ERP发货地点id
        consignerAlias: '',	        //Y	发货地点简称

        prodMedialCode: '',	        //Y	ERP货品NC编码
        prodMedialID: '',	          //Y	ERP货品Id

        supplyTime: '',	            //Y	业务日期,发货时间
        tranRequire: '',	          //N	服务要求
        supplyTransportGoodsFormList:[
          {
            prodName: '',       //Y	货品名称
            amount: '',         //Y	计划发货数
            amountUnitStr: '', //Y	计划发货数单位
            amountUnitid: '',   //Y	计划发货数单位Id
            price: '',          //N	货品赔付价
            tranRequire:'',       //服务要求
          }
        ],	//Y	货品信息
      },
    };
  },
  created() {
    this.subForm.supplyTime = this.$options.filters.timeFormat(new Date().getTime(),'yyyy-mm-dd')
    this.supplyTime = new Date(this.subForm.supplyTime)
  },
  mounted() {
    this.queryProductUnits()
  },
  methods: {
    // 获取收货单位
    getListWithRawMaterial(sval) {
      if(!sval)this.receiverSval = ''
      this.showPickerWithRawMaterial = true
      let data = {
        name: sval?sval:''
      }
      this.$api.apis.getListWithRawMaterial(data).then(res => {
        this.withRawMaterialList = res.rsObj
      });
    },
    // 选择收货单位
    changeWithRawMaterialList(item) {
      this.subForm.receiverId = item.id || ''
      this.subForm.receiverName = item.name || ''
      this.receiver_id = item.ext3 || ''
      // start-清空后面的表内容
      this.subForm.prodMedialCode = ''	        //Y	ERP货品NC编码
      this.subForm.prodMedialID = ''	          //Y	ERP货品Id
      this.subForm.supplyTransportGoodsFormList[0].prodName = ''; //Y	货品名称
      this.subForm.supplyTransportGoodsFormList[0].amount = ''; //Y	计划发货数
      this.subForm.supplyTransportGoodsFormList[0].price = ''; //N	货品赔付价
      this.subForm.consignerMedialID = ''      //Y	ERP发货单位Id
      this.subForm.consignerName = ''          //Y	发货单位名称
      this.subForm.consignerCode = ''	        //Y	ERP发货单位NC编码
      this.subForm.consignerAddressMedialID = ''	//Y	ERP发货地点id
      this.subForm.consignerAlias = ''	        //Y	发货地点简称
      // end-清空后面的表内容
      this.getQuerySenconsAddrByScId(item.id)
      this.showPickerWithRawMaterial = false;
    },
    // 搜索获取收货单位
    receiverSFun() {
      this.getListWithRawMaterial(this.receiverSval)
    },
    // 根据收货单位Id获取收货地点信息
    getQuerySenconsAddrByScId(id) {
      let data = {
        consigner_id:id
      }
      this.$api.apis.getQuerySenconsAddrByScId(data).then(res => {
        // console.log('获取收货地点信息',res)
        let list = res.rsObj.list
        if(list&&list.length>0){
          this.receiverAddressList = list.map(item=>{
              return {
                id:item.id,
                name:item.alias,
                contacts:item.contacts,
                phone:item.phone,
                regionid:item.regionid,
                region_name:item.region_name,
                address:item.address
              }
          })
          this.subForm.receiverAddressId = list[0].id
          this.subForm.receiverAddress = list[0].address
          this.subForm.receiverAlias = list[0].alias
          this.subForm.receiverContacts = list[0].contacts
          this.subForm.receiverTel = list[0].phone
          this.subForm.receiverRegionid = list[0].regionid
          this.subForm.receiverRegionName = list[0].region_name
        }
      });
    },
    // 打开选择收货地点
    openReceiverAddressList(value) {
      if(!this.receiver_id){
        this.$toast('请选择收货单位')
        return false
      }
      this.showPickerReceiverAddress = true;
    },
    // 选择收货地点
    onConfirmReceiverAddressList(value) {
      this.subForm.receiverAddressId = value.id
      this.subForm.receiverAddress = value.address
      this.subForm.receiverAlias = value.name
      this.subForm.receiverContacts = value.contacts
      this.subForm.receiverTel = value.phone
      this.subForm.receiverRegionid = value.regionid
      this.subForm.receiverRegionName = value.region_name
      // start-清空后面的表内容
      this.subForm.prodMedialCode = ''	        //Y	ERP货品NC编码
      this.subForm.prodMedialID = ''	          //Y	ERP货品Id
      this.subForm.supplyTransportGoodsFormList[0].prodName = ''; //Y	货品名称
      this.subForm.supplyTransportGoodsFormList[0].amount = ''; //Y	计划发货数
      this.subForm.supplyTransportGoodsFormList[0].price = ''; //N	货品赔付价
      this.subForm.consignerMedialID = ''      //Y	ERP发货单位Id
      this.subForm.consignerName = ''          //Y	发货单位名称
      this.subForm.consignerCode = ''	        //Y	ERP发货单位NC编码
      this.subForm.consignerAddressMedialID = ''	//Y	ERP发货地点id
      this.subForm.consignerAlias = ''	        //Y	发货地点简称
      // end-清空后面的表内容
      this.showPickerReceiverAddress = false;
    },
    // 获取货品名称
    getProductsByErp() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      if(!this.receiver_id){
        this.$toast('请选择收货单位')
        return false
      }
      if(!this.showPickerProducts)this.productsSval=''
      this.showPickerProducts = true
      let data = {
        receiver_id: this.receiver_id,
        name: this.productsSval?this.productsSval:''
      }
      this.$api.apis.getProductsByErp(data).then(res => {
      if(!res.rsObj || res.rsObj.length < 1){
        this.productsList = [];
        this.$toast('暂无货品')
        return false
      }
        this.productsList = res.rsObj.map(item=>{
            return {
              id: item.PCM_ID,
              name: item.PCM_Name,
              materId: item.PCM_MaterId
            }
        })
        this.$toast.clear()
      });
    },
    // 选择货品名称
    changeGoods(item) {
      this.subForm.supplyTransportGoodsFormList[0].prodName = item.name;
      this.subForm.prodMedialID = item.id;
      this.subForm.prodMedialCode = item.materId;
      // start-清空后面的表内容
      this.subForm.supplyTransportGoodsFormList[0].amount = ''; //Y	计划发货数
      this.subForm.supplyTransportGoodsFormList[0].price = ''; //N	货品赔付价
      this.subForm.consignerMedialID = ''      //Y	ERP发货单位Id
      this.subForm.consignerName = ''          //Y	发货单位名称
      this.subForm.consignerCode = ''	        //Y	ERP发货单位NC编码
      this.subForm.consignerAddressMedialID = ''	//Y	ERP发货地点id
      this.subForm.consignerAlias = ''	        //Y	发货地点简称
      // end-清空后面的表内容
      this.showPickerProducts = false;
    },
    // 获取计量单位
    queryProductUnits() {
      let data = {
        pname:''
      }
      this.$api.apis.queryProductUnits(data).then(res => {
        let unitList = res.rsObj.unitList
        this.productUnitsList = unitList.map(item=>{
            return {
              id: item.id,
              name: item.unitName
            }
        })
        if(this.productUnitsList&&this.productUnitsList.length>0){
          this.subForm.supplyTransportGoodsFormList[0].amountUnitid = this.productUnitsList[0].id;
          this.subForm.supplyTransportGoodsFormList[0].amountUnitStr = this.productUnitsList[0].name;
        }
      });
    },
    // 选择计量单位
    onConfirmProductUnits(item) {
      this.subForm.supplyTransportGoodsFormList[0].amountUnitid = item.id;
      this.subForm.supplyTransportGoodsFormList[0].amountUnitStr = item.name;
      this.showPickerProductUnits = false
    },
    // 获取发货单位
    getconsignerByErp(sval) {
      if(!sval)this.consignerSval = ''
      if(!this.receiver_id){
        this.$toast('请选择收货单位')
        return false
      }
      if(!this.subForm.prodMedialID){
        this.$toast('请选择货品')
        return false
      }
      this.showPickerConsigner = true
      let data = {
        receiver_id: this.receiver_id,
        prod_id: this.subForm.prodMedialID,
        name: this.consignerSval
      }
      this.$api.apis.getconsignerByErp(data).then(res => {
        this.consigneesGetList = res.rsObj.map(item=>{
            return {
              id: item.XOB_ID,
              name: item.XOB_Name,
              code: item.XOB_Code
            }
        })
        this.getMineByErp()
      })
    },
    // 搜索获取发货单位
    consignerSFun() {
      this.getconsignerByErp(this.consignerSval)
    },
    // 选择发货单位
    changeConsignerByErp(item) {
      this.subForm.consignerId = item.id;
      this.subForm.consignerName = item.name;
      this.subForm.consignerCode = item.code;
      this.getMineByErp()
      this.showPickerConsigner = false;
    },
    // 获取发货地点
    getMineByErp(sval) {
      let data = {
        receiver_id: this.receiver_id,
        consigner_hide_id: this.subForm.consignerId
      }
      this.$api.apis.getMineByErp(data).then(res => {
        if(!res.rsObj){return false}
        this.consignerAddressList = res.rsObj.map(item=>{
            return {
              id: item.XOG_ID,//ERP发货地点Id
              compy: item.XOG_Compy,//ERP发货单位Id
              name: item.XOG_OfferArea//ERP发货地点名称
            }
        })
        this.subForm.consignerAddressMedialID = this.consignerAddressList[0].id;
        this.subForm.consignerMedialID = this.consignerAddressList[0].compy;
        this.subForm.consignerAlias = this.consignerAddressList[0].name;
      });
    },
    // 选择发货地点
    onConfirmConsignerAddressList(value) {
      this.subForm.consignerAddressMedialID = value.id;
      this.subForm.consignerMedialID = value.compy
      this.subForm.consignerAlias = value.name;
      this.showPickerConsignerAddress = false;
    },
    // 选择发货时间
    onConfirmSupplyTime(value) {
      this.subForm.supplyTime = this.$options.filters.timeFormat(new Date(value).getTime(),'yyyy-mm-dd')
      this.showPickerSupplyTime = false;
    },
    onClickLeft() {
      this.showPickerWithRawMaterial = false;
      this.showPickerReceiverAddress = false;
      this.showPickerProducts = false;
      this.showPickerProductUnits = false;
      this.showPickerSupplyTime = false;
      this.showPickerConsigner = false;
      this.showPickerConsignerAddress = false;
    },
    onSubmit(values) {
      console.log('subForm', this.subForm);
      this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
      });
      let data = {
        ...this.subForm
      }
      console.log(data)
      if(data.supply_point_id == ''){
        this.$toast("处理网点");
        return false;
      }
      if(data.receiverId == ''){this.$toast('请选择收货单位');return false}	            //Y	收货单位id
      if(data.receiverAddressId == ''){this.$toast('请选择收货地点');return false}	    //Y	收货地点id
      // if(data.receiverContacts == ''){this.$toast('请选择收货联系人');return false}       //Y 收货联系人
      // if(data.receiverRegionid == ''){this.$toast('请选择收货地点邮编');return false}       //Y	收货地点邮编
      // if(data.receiverTel == ''){this.$toast('请选择收货地点手机电话');return false}            //Y	收货地点手机电话
      if(data.prodMedialID == ''){this.$toast('请选择ERP货品');return false}	          //Y	ERP货品Id
      if(data.supplyTransportGoodsFormList[0].prodName == ''){this.$toast('请选择货品名称');return false}       //Y	货品名称
      if(data.supplyTransportGoodsFormList[0].amount == ''){this.$toast('请输入计划发货数');return false}         //Y	计划发货数
      if(data.supplyTransportGoodsFormList[0].amountUnitid == ''){this.$toast('请选择计划发货数单位');return false}   //Y	计划发货数单位
      if(data.consignerName == ''){this.$toast('请选择ERP发货单位');return false}      //Y	ERP发货单位Id
      // if(data.consignerCode == ''){this.$toast('请选择ERP发货单位NC编码');return false}	        //Y	ERP发货单位NC编码
      if(data.consignerAlias == ''){this.$toast('请选择ERP发货地点');return false}	//Y	ERP发货地点id
      if(data.supplyTime == ''){this.$toast('请选择发货时间');return false}	            //Y	发货时间
      delete data.consignerId
      this.$api.apis.addRawMaterial(data).then(res => {
        this.$toast.clear()
        if(res.flag=='200'){
          // this.$toast.success('提交成功');
          this.$dialog.alert({
            message: '原材料下单成功！',
            confirmButtonText:'确定'
          }).then(() => {
            this.$router.push({path:'/Invoice'})
          });
        }else{
          this.$toast(res.msg);
        }
      });
    },
  },
  destroyed() {
  },
  filters: {}
};
</script>
<style scoped lang="less">
  @import '../../styles/order.less';
</style>



// WEBPACK FOOTER //
// src/pages/Invoice/AddMaterial.vue